module.exports = {"videoYTID":"WR--4bGQB2A"}


//////////////////
// WEBPACK FOOTER
// ./js/viscom/settings.json
// module id = 555
// module chunks = 0